// statically define response wrapper with unknown result schema

import { z } from '@harvestiq/zod';

export type IBarchartApiResponse<Type> = {
  status: {
    code: number | string;
    message: string;
  };
  results: Type[] | null;
};

export type BarchartResponse<Type> = IBarchartApiResponse<Type>;

// requestor is expected to define a more specific schema and parse the results
export const unknownBarchartResponseSchema = z.object({
  status: z.object({
    code: z.coerce.number(),
    message: z.string(),
  }),
  results: z.array(z.unknown()).nullable(),
});

// dynamically define response wrapper with a specific result schema
export const makeBarchartResponseWrapperSchema = <T>(schema: z.ZodType<T>) => {
  return unknownBarchartResponseSchema.extend({
    results: z.array(schema).nullable(),
  });
};
